{
  "name": "mastra",
  "version": "0.18.0",
  "license": "Apache-2.0",
  "description": "cli for mastra",
  "type": "module",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "bin": {
    "mastra": "./dist/index.js"
  },
  "exports": {
    ".": "./dist/index.js",
    "./package.json": "./package.json",
    "./telemetry-loader": "./dist/commands/dev/telemetry-loader.js",
    "./dist/*": [
      "./dist/*",
      "./dist/*.js"
    ]
  },
  "files": [
    "dist",
    "CHANGELOG.md"
  ],
  "scripts": {
    "build:lib": "tsup --silent --config tsup.config.ts",
    "test": "vitest run",
    "test:watch": "vitest watch",
    "clean": "rm -rf dist && rm -rf node_modules",
    "typecheck": "tsc --noEmit --incremental",
    "lint": "eslint ."
  },
  "keywords": [
    "mastra",
    "cli",
    "ai",
    "llm",
    "llms",
    "agent",
    "agents",
    "dev",
    "development",
    "deploy",
    "deployment",
    "build",
    "workflow",
    "typescript",
    "command-line",
    "devtools"
  ],
  "author": "",
  "dependencies": {
    "@clack/prompts": "^0.11.0",
    "@expo/devcert": "^1.2.0",
    "@mastra/deployer": "workspace:^",
    "@mastra/loggers": "workspace:^",
    "@opentelemetry/auto-instrumentations-node": "^0.62.1",
    "@opentelemetry/core": "^2.0.1",
    "@opentelemetry/exporter-trace-otlp-grpc": "^0.203.0",
    "@opentelemetry/exporter-trace-otlp-http": "^0.203.0",
    "@opentelemetry/instrumentation": "^0.203.0",
    "@opentelemetry/resources": "^2.0.1",
    "@opentelemetry/sdk-node": "^0.203.0",
    "@opentelemetry/sdk-trace-base": "^2.0.1",
    "@opentelemetry/semantic-conventions": "^1.36.0",
    "@webcontainer/env": "^1.1.1",
    "commander": "^12.1.0",
    "dotenv": "^16.6.1",
    "execa": "^9.6.0",
    "fs-extra": "^11.3.2",
    "get-port": "^7.1.0",
    "open": "^10.1.2",
    "picocolors": "^1.1.1",
    "posthog-node": "4.18.0",
    "prettier": "^3.6.2",
    "shell-quote": "^1.8.3",
    "strip-json-comments": "^5.0.3",
    "tcp-port-used": "^1.0.2",
    "yocto-spinner": "^0.2.3"
  },
  "devDependencies": {
    "@commander-js/extra-typings": "^14.0.0",
    "@internal/lint": "workspace:*",
    "@internal/playground": "workspace:*",
    "@internal/types-builder": "workspace:*",
    "@mastra/core": "workspace:*",
    "@microsoft/api-extractor": "^7.52.8",
    "@types/fs-extra": "^11.0.4",
    "@types/node": "^20.19.0",
    "@types/shell-quote": "^1.7.5",
    "@types/tcp-port-used": "^1.0.4",
    "eslint": "^9.37.0",
    "memfs": "^4.17.2",
    "rollup": "^4.50.2",
    "tsup": "^8.5.0",
    "type-fest": "^4.41.0",
    "typescript": "^5.8.3",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "@mastra/core": ">=0.24.0-0 <0.25.0-0",
    "zod": "^3.25.0 || ^4.0.0"
  },
  "homepage": "https://mastra.ai",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/mastra-ai/mastra.git",
    "directory": "packages/cli"
  },
  "bugs": {
    "url": "https://github.com/mastra-ai/mastra/issues"
  },
  "publishConfig": {
    "access": "public",
    "publish-branch": [
      "main",
      "0.x"
    ]
  }
}
